/**
 * This module is a helper to be used on the lead actions to send on demand events to Ga / Segment
 * This will create the event object to be sent by retrieving the respective data-values from the event.target
  */
(function leadFormEventsHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousModule = global.NewHomeSource.LeadFormEventsHandler;

  const basicLeadTopics = [
    'IDoNotHaveAnAgent'
  ];

  /**
   * @constructs NewHomeSource.LeadFormEventsHandler
   */
  function LeadFormEventsHandler() {
  }

  /**
   * This method will invoke the custom event "trackOnDemandEvent" located on eventTracker.js
   * Attach a given segment/ga event object.
   * @param {object} event
   */
  function triggerOnDemandEvent(event) {
    if (document.body.dispatchEvent) {
      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent',
        {
          detail: { data: event }
        }));
    }
  }

  /**
   * This method will extract the lead topics from the data of the form.
   * the object basicLeadTopics will contains a list of possible topics options.
   * the formData will come in 2 different forms, as an object and as a FormData object.
   * So if the info comes as a FormData, then it is parsed as an object to then extract the topics.
   * @param {object} formData
   */
  function getLeadTopics(formData) {
    var topics = '';

    if (!formData) {
      return topics;
    }

    if (formData instanceof FormData) {
      var object = {};
      formData.forEach(function (value, key) {
        object[key] = value;
      });
      formData = object;
    }

    basicLeadTopics.forEach(item => {
      if (formData.hasOwnProperty(item) && (formData[item] === true || formData[item] === 'true')) {
        topics += (topics === '')
          ? item
          : ', '+item;
      }
    });
    
    return topics;
  }

  /**
   * This method will extract the necessary properties for the event in the SRP.
   */
  function getProperties(event, eventForSegment) {
    const commonProperties = document.querySelector('#data-commonProperties_' + event.target.dataset.card_id);
    if (!commonProperties || !commonProperties.dataset) {
      return eventForSegment;
    }
    const propertiesForSegment = Object.assign({}, eventForSegment, commonProperties.dataset);
    return propertiesForSegment;
  }

  /**
   * This method will built the event for segment object
   * by retrieving the required data values when the lead is submitted.
   * @param {object} event event element that triggered the action
   */
  function getSegmentEvent(event, formData) {
    let segmentEventName = event.target.dataset.submittedEvent;
    let segmentEventButtonAction = event.target.dataset.segmentEventButton_action;
    let segmentRecipient = event.target.dataset.submittedRecipient;
    let leadTopics = getLeadTopics(formData);
    let eventForSegment = {
      event: 'Lead Modal Form Submitted',
      eventType: 'segmentEvent',
      button_action: ''
    };

    if (event.target.dataset.card_id) {
      eventForSegment = getProperties(event, eventForSegment);
    }

    if (segmentEventName) {
      eventForSegment.event = segmentEventName;
    }

    if (segmentEventButtonAction) {
      eventForSegment.button_action = segmentEventButtonAction;
    }

    if (segmentRecipient) {
      eventForSegment.recipient = segmentRecipient;
    }

    if (leadTopics) {
      eventForSegment.lead_form_topics = leadTopics;
    }

    if (event.target.dataset.builder) {
      eventForSegment.builder_id = event.target.dataset.builder;
    }

    if (event.target.dataset.builderName) {
      eventForSegment.builder_name = event.target.dataset.builderName;
    }

    if (event.target.dataset.community) {
      eventForSegment.community_id = event.target.dataset.community;
    }

    return eventForSegment;
  }

  /**
   * This method is called when the lead is already submitted, it calls a segmentEvent object to be built
   * and pass the event object to the custom event call.
   * @param {object} targetEvent event element that triggered the action.
   */
    document.body.addEventListener('sendLeadSubmittedSegmentEvent',
      function (e) {
      let eventForSegment = getSegmentEvent(e.detail.targetEvent, e.detail.formData);
      triggerOnDemandEvent(eventForSegment);
    });

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.LeadFormEventsHandler to the previous script.
   */
  LeadFormEventsHandler.noConflict = function noConflict() {
    global.NewHomeSource.LeadFormEventsHandler = previousModule;
    return LeadFormEventsHandler;
  };

  global.NewHomeSource.LeadFormEventsHandler = LeadFormEventsHandler;

  return LeadFormEventsHandler;
}(window));
